import { animateChild, query, sequence, transition, trigger } from '@angular/animations';

const animateGrowChild = query('@Grow', animateChild(), { limit: 1, optional: true });

export const SearchExpand = trigger('SearchExpand', [
    transition('not-expanded => expanded', [sequence([animateGrowChild])]),
    transition('expanded => not-expanded', [sequence([animateGrowChild])]),
]);
